import axios from 'axios';

const API_URL = 'https://jel2dd8c5i.execute-api.us-east-1.amazonaws.com/prod/fund';

export const GetAllFunds = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const UpdateFund = async (fundId, fundName, targetAUM, currentAUM, fundLPPortal) => {
  try {
    const url = `${API_URL}`;
    const requestBody = {
      fund_name: fundName,
      target_aum: parseFloat(targetAUM), // Convert to float64
      current_aum: parseFloat(currentAUM), // Convert to float64
      fund_lp_portal: fundLPPortal,
    };
    const response = await axios.put(url, {
      body: JSON.stringify(requestBody),
      queryStringParameters: { fundId: fundId.toString() },
    }, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};


export const DeleteFund = async (fundId) => {
  try {
    const url = `${API_URL}?fundId=${fundId}`;
    console.log("Requesting to delete the fund id :: " + fundId);
    
    const response = await axios.delete(url, {
      body: JSON.stringify("{}"),
      queryStringParameters: { fundId },
    },{
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

